module.exports = __webpack_public_path__ + "img/case_3.a5da56f5.png";